import * as yup from 'yup';
import { evidenceForm as TEXT } from 'locales/en/dispute';

export const FIELD_NAMES = {
  evidence_1: 'evidence_1',
  evidence_2: 'evidence_2',
  evidence_3: 'evidence_3',
  evidence_4: 'evidence_4',
};

export const defaultValues = {
  [FIELD_NAMES.evidence_1]: null,
  [FIELD_NAMES.evidence_2]: null,
  [FIELD_NAMES.evidence_3]: null,
  [FIELD_NAMES.evidence_4]: null,
};
const FILE_SIZE = 2097152; //2MB
const FILE_TYPES = ['image/jpeg', 'image/png', '.pdf', 'application/pdf'];

export const fileValidation = yup
  .mixed()
  .nullable()
  .required(TEXT.errors.adyenEvidence.required)
  .test('size', TEXT.errors.adyenEvidence.max, (value) => {
    if (!value?.lastModified) {
      return true;
    } else {
      return value && value.size <= FILE_SIZE;
    }
  })
  .test('type', TEXT.errors.adyenEvidence.type, (value) => {
    if (!value?.lastModified) {
      return true;
    } else {
      return value && FILE_TYPES.indexOf(value.type) > -1;
    }
  });

const schema = yup.object().shape({
  [FIELD_NAMES.evidence_1]: fileValidation,
  [FIELD_NAMES.evidence_2]: fileValidation,
  [FIELD_NAMES.evidence_3]: fileValidation,
  [FIELD_NAMES.evidence_4]: fileValidation,
});

export default schema;

export const fileSchema = (fieldNames) => {
  const shape = {};
  fieldNames.forEach((fieldName) => {
    shape[fieldName] = fileValidation;
  });
  return yup.object().shape(shape);
};
